/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
const homeAnchorElement = document.querySelector(".HorizontalList__Item a[href*='/collections/home-essentials'].Header__gender-option")
const homeKeywords = ["home", "tablecloths", "tableware", "vase", "diptyque", "perfume", "molecule", "placemat", "bathrobe", "blanket", "homewear", "candle", "creams", "fragrance", "fragance"]
const expandHomeDropdown = () => {
   homeAnchorElement.parentElement.parentElement.querySelectorAll(".HorizontalList__Item a").forEach(function (el) {
      el.classList.remove("hovered-by-url");
   })
   homeAnchorElement.parentElement.classList.add("is-expanded", "is-hovered");
   homeAnchorElement.dataset.hovered_by_url = "true";
   homeAnchorElement.nextElementSibling.setAttribute("aria-hidden", "false");

}
document.addEventListener("DOMContentLoaded", function () {
   homeKeywords.forEach(function (keyword) {
      if (window.location.href.indexOf(keyword) != -1) {
         expandHomeDropdown()
      }
   })
   if (window.location.href.indexOf("men") !== -1 && window.location.href.indexOf("women") === -1) {
      document.querySelector(".HorizontalList__Item a[href*='/pages/" + "men" + "'].Header__gender-option").classList.add("hovered-by-url");
      document.querySelector(".HorizontalList__Item a[href*='/pages/" + "men" + "'].Header__gender-option").dataset.hovered_by_url = "true";
   }
   else if (window.location.href.indexOf("women") != -1) {
      document.querySelector(".HorizontalList__Item a[href*='/pages/" + "women" + "'].Header__gender-option").classList.add("hovered-by-url");
      document.querySelector(".HorizontalList__Item a[href*='/pages/" + "women" + "'].Header__gender-option").dataset.hovered_by_url = "true";
   }
   else if (window.location.href.indexOf("home") != -1) {
      document.querySelector(".HorizontalList__Item a[href*='/collections/home-essentials'].Header__gender-option").dataset.hovered_by_url = "true";
      document.querySelector(".HorizontalList__Item a[href*='/collections/home-essentials'].Header__gender-option").nextElementSibling.setAttribute("aria-hidden", "false");
   }

   document.querySelectorAll(".HorizontalDropdownMenu").forEach(function (el) {
      if (el.dataset.category === "Home") {
         expandHomeDropdown()
      }
   })

});

document.querySelectorAll(".HorizontalList__Item[aria-haspopup]").forEach(function (tag) {
   tag.addEventListener("mouseover", function () {
      document.querySelectorAll(".HorizontalList__Item a").forEach(function (el) {
         el.classList.remove("hovered-by-url");
      })
   })
})

document.querySelector(".Header__Wrapper").addEventListener("mouseleave", function () {
   document.querySelector(".PageOverlay").classList.remove("is-visible");
   document.querySelectorAll(".HorizontalList__Item a.Header__gender-option").forEach(function (el) {
      if (el.dataset.hovered_by_url == "true") {
         document.querySelectorAll(".HorizontalList__Item").forEach(function (element) {
            element.classList.remove("is-hovered");
         })
         document.querySelectorAll(".HorizontalDropdownMenu").forEach(function (element) {
            element.setAttribute("aria-hidden", "true");
         })
         el.parentElement.classList.add("is-hovered");
         el.parentElement.classList.add("is-expanded");

         el.nextElementSibling.setAttribute("aria-hidden", "false");
      }
   })
})

document.querySelectorAll(".HorizontalDropdownMenu .MainLinklist__Item > a").forEach(function (el) {
   el.addEventListener("mouseenter", function (e) {
      document.querySelector(".PageOverlay").classList.add("is-visible");
   })
})

document.querySelectorAll(".LinklistSubLinks").forEach(function (el) {
   if (el.childElementCount < 2) {
      el.classList.add("one-column");
      el.parentElement.classList.add("one-column");
   }
})



